//Types
import { GlobalAction, InitialStateType } from "@context/types";

//Reducer
import { dataReducer } from "@context/reducers/data";
import { pageReducer } from "@context/reducers/page";
import { legalPersonalityReducer } from "@context/reducers/legalpersonality";
import { patientReducer } from "@context/reducers/patient";
import { describeReducer } from "@context/reducers/describeCase";
import { anonymousReducer } from "@context/reducers/anonymous";
import { loadingReducer } from "@context/reducers/loading";

export const mainReducer = (
  {
    data,
    patient,
    page,
    islegal,
    describe,
    anonymous,
    loading,
  }: InitialStateType,
  action: GlobalAction
) => ({
  data: dataReducer(data, action),
  page: pageReducer(page, action),
  islegal: legalPersonalityReducer(islegal, action),
  patient: patientReducer(patient, action),
  describe: describeReducer(describe, action),
  anonymous: anonymousReducer(anonymous, action),
  loading: loadingReducer(loading, action),
});
